import { Badge, Flex, List, Tooltip, Typography } from "antd";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/store";
import { setSelectedDid } from "../../../store/slices/SmsDids.slice";
import { formatPhoneNumber } from "../../../utils/phoneLib";
import { FaUser } from "react-icons/fa";
import { HeadingText } from "../../generic/Typography";
import {
  setSelectedConversation,
} from "../../../store/slices/conversation.slice";
import { SmsDid } from "../../../interfaces/Did.type";
import { useCallback, memo, useMemo } from "react";

const avatarStyle: React.CSSProperties = {
  height: "1rem",
  width: "1rem",
  marginTop: "2px",
};

const didCardStyle: React.CSSProperties = {
  width: "100%",
  borderRadius: 6,
};

const cardStyle = {
  border: "none",
  padding: "10px 10px 10px 20px",
  borderRadius: "6px",
  cursor: "pointer",
};

const didlabelStyle: React.CSSProperties = {
  color: "rgb(119, 117, 135)",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "20px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: "fit-content",
  maxWidth: "220px"
};

const UserDidItem = memo(({
  userDid,
  isSelected,
  setIsNewConversation,
  showCounter,
  assigned
}: {
  userDid: SmsDid;
  isSelected: boolean;
  setIsNewConversation?: Function;
  showCounter: boolean
  assigned?: boolean;
}) => {
  const dispatch: AppDispatch = useDispatch();

  const onClickHandler = useCallback((didId: string) => {
    requestAnimationFrame(() => {
      dispatch(setSelectedDid(didId));
      dispatch(setSelectedConversation(null));
      if (setIsNewConversation) {
        setIsNewConversation(false);
      }
    });
  }, [dispatch, setIsNewConversation]);

  const memoizedClickHandler = useMemo(() => {
    return () => onClickHandler(userDid.did);
  }, [onClickHandler, userDid.did]);

  return (
    <List.Item
      style={{
        ...cardStyle,
        background: isSelected ? "#eff4fb" : "#fff",
      }}
    >
      <Flex justify="space-between" style={didCardStyle}>
        <Flex 
          justify="space-between"
          style={didCardStyle}
          onClick={memoizedClickHandler} // Use the memoized handler directly
        >
          <Flex style={{
            minHeight: "40px",
            alignItems: "center"
          }} gap={10}>
            {
              assigned ? (
                <FaUser style={avatarStyle} />
              ) : (
                <span style={{ ...avatarStyle, display: "inline-block" }} />
              )
            }
            <Flex vertical={true}>
              <HeadingText
                text={formatPhoneNumber(userDid.did) as string}
              ></HeadingText>
              <Tooltip title={userDid.label}><Typography.Text style={didlabelStyle}>{userDid.label}</Typography.Text></Tooltip>
            </Flex>
          </Flex>
          <div style={{ width: "50px" }}>
            {Number(userDid.unread_messages_count) > 0 && showCounter ? (
              <Badge
                count={`${Number(userDid.unread_messages_count)}`.padStart(2, "0")}
                showZero
                color="#653BFA"
              />
            ) : Number(userDid.unread_conversations_count) > 0 ? (
              <Badge
                text=" "
                showZero={false}
                color="#653BFA"
              />
            ) : (
              <span style={{ display: "inline-block", width: 24 }} />
            )}
          </div>
        </Flex>
      </Flex>
    </List.Item>
  );
});

export default UserDidItem;
